module.exports = __webpack_public_path__ + "static/media/undraw_data_25jw.1c3caf0d.svg";